export const clientJourney = {
  heading: 'Client Journey',
  subheading: 'The Path to Clarity and Forward Motion',
  intro: [
    "Most people don't seek a coach because everything is going great. Something's stuck. Something's shifting. Something's missing.",
    "You might not even know what it is yet—just that something feels off. You've tried thinking your way through it. You've read the books, listened to the podcasts, maybe even tried therapy. And while those have their place, they didn't quite get you moving.",
    "That's where coaching comes in—not as another quick fix, but as a structured path toward lasting clarity and momentum.",
  ],
  steps: [
    {
      number: 'ONE',
      title: 'The First Conversation',
      subtitle: 'A real talk—not a sales pitch.',
      body: "We start with a free consultation. No pressure. No coaching tricks. Just a human conversation about where you are, what's pulling at you, and whether coaching with me feels like the right fit.",
      bullets: [
        'What brought you to coaching at this moment',
        'Areas where you feel stuck or uncertain',
        "What you've tried already",
        'What meaningful progress would look like for you',
      ],
      footer: "If it doesn't feel right, no hard feelings. If it does, we'll make a plan together for next steps.",
      cta: 'Schedule Your Free Consultation',
    },
    {
      number: 'TWO',
      title: 'Setting the Course',
      subtitle: "We don't jump into action. We start by listening.",
      body: 'In the first few sessions, we identify what really matters to you—your values, your goals, and the parts of you that are caught in conflict. Using the Internal Family Systems (IFS) model, we map your inner landscape, not as diagnosis, but as direction.',
      bullets: [
        "You'll start to see why you're stuck, not just that you're stuck",
        "We'll identify the parts of you that are pulling in different directions",
        "You'll begin building a relationship with your authentic Self",
        "We'll establish clear markers for progress that align with your values",
      ],
      footer: 'This foundation becomes the compass for our work together.',
    },
    {
      number: 'THREE',
      title: 'Doing the Work',
      subtitle: 'Momentum meets meaning.',
      body: "This is where transformation happens. We tackle what's holding you back—habits, patterns, relationships, fears—with both compassion and strategy. We translate insight into action.",
      bullets: [
        "You'll learn how to align different parts of yourself around shared goals",
        "We'll address specific obstacles with practical tools and frameworks",
        "You'll practice new approaches in real-life situations between sessions",
        "We'll regularly assess what's working and adjust our approach as needed",
      ],
      footer: "You'll find yourself moving forward with less inner conflict and more sustainable energy.",
    },
    {
      number: 'FOUR',
      title: 'Integration',
      subtitle: "You don't just change. You become more you.",
      body: "Over time, the goal isn't just to \"fix\" things. It's to live with clarity, confidence, and integrity—where your actions align with your values and your progress feels sustainable.",
      bullets: [
        "You'll solidify new patterns of thinking and behaving",
        "We'll ensure your growth is sustainable beyond our coaching relationship",
        "You'll develop your own internal coaching voice",
        "You'll gain confidence in navigating future challenges and transitions",
      ],
      footer: "Coaching ends when you no longer need it—not because you've arrived at some perfect destination, but because you've found your own footing for the road ahead.",
    },
  ],
  closingCta: 'Schedule Your Free Consultation',
  closingBody: "You don't have to be in crisis to ask for help. You just have to be ready for something different. The first step is a conversation—no pressure, just possibility.",
}
